import React from 'react';


const SearchForm = ({setSearchTerm}) => {
  return (
    <div id="search-form">
      <div className="row search-panel-form">
        <div className="col-sm-10 col-md-3 col-lg-3  mt-20 form-group">
          <h3 className='mt-5 mb-0'>Filter Organizations</h3>
        </div>
        <div className="col-sm-10 col-md-3 col-lg-9 form-group mt-20">
          <input
            name="publisher-name"
            type="text"
            className="form-control"
            placeholder="Search here"
            id="publisher-name"
            onChange={e => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchForm;
